import React from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_boarding-school-fit/artifacts/5kmsljm9_ESA%20Final%20Logo.png";

const CookiePolicy = () => {
  return (
    <div className="min-h-screen bg-[#FDFCF8]">
      {/* Header */}
      <header className="bg-[#FDFCF8] border-b border-[#E2E8F0] py-4">
        <div className="container mx-auto px-4 md:px-8 max-w-7xl flex items-center justify-between">
          <Link to="/">
            <img src={LOGO_URL} alt="Elite School Advisory" className="h-12 w-auto" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-[#2B4C7E] hover:text-[#C9A227] transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 md:px-8 max-w-4xl py-16">
        <h1
          className="text-3xl md:text-4xl font-semibold text-[#1A202C] mb-8"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Cookie Policy
        </h1>

        <div className="prose prose-lg max-w-none text-[#4A5568]">
          <p className="text-sm text-[#4A5568] mb-8">
            Last updated: December 2025
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              1. What Are Cookies
            </h2>
            <p>
              Cookies are small text files that are stored on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and to provide information to the owners of the site.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              2. How We Use Cookies
            </h2>
            <p className="mb-4">Elite School Advisory uses cookies to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Ensure the website functions properly</li>
              <li>Remember your preferences and settings</li>
              <li>Understand how you use our website</li>
              <li>Improve your browsing experience</li>
              <li>Analyse website traffic and performance</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              3. Types of Cookies We Use
            </h2>
            
            <h3 className="text-lg font-medium text-[#1A202C] mt-6 mb-3">Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you, such as setting your privacy preferences or filling in forms.
            </p>

            <h3 className="text-lg font-medium text-[#1A202C] mt-6 mb-3">Analytics Cookies</h3>
            <p>
              These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us know which pages are the most and least popular.
            </p>

            <h3 className="text-lg font-medium text-[#1A202C] mt-6 mb-3">Functional Cookies</h3>
            <p>
              These cookies enable the website to provide enhanced functionality and personalisation. They may be set by us or by third-party providers whose services we have added to our pages.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              4. Managing Cookies
            </h2>
            <p>
              Most web browsers allow you to control cookies through their settings. You can set your browser to refuse cookies or delete certain cookies. However, if you choose to block or delete cookies, some parts of our website may not function properly.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              5. Third-Party Cookies
            </h2>
            <p>
              Some cookies on our website are set by third parties, such as analytics providers. We do not control these cookies. Please refer to the respective privacy policies of these third parties for more information.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-medium text-[#1A202C] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              6. Contact Us
            </h2>
            <p>
              If you have questions about our use of cookies, please contact us at:
            </p>
            <p className="mt-4">
              <strong>Elite School Advisory</strong><br />
              Operated by Mindways Consulting Pvt Ltd<br />
              New Delhi, India<br />
              Email: eliteschooladvisory@gmail.com<br />
              Phone: +91 98180 65496
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default CookiePolicy;
